import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExploreAlternativeListComponent, InviteUserToRegisterComponent, NavbarComponent, TypeaheadUserPublicComponent } from '../../organisms/organisms.index';
import './Explore.component.scss';

export function ExploreComponent(props: any) {

  return (
    <div className='search-users-container fluid-container page-container'>
      <NavbarComponent hideBack={true} noNavigateHome={true} />
      <div className='list-title-container d-flex'>
        <div className='list-title'>
          <h2><FormattedMessage id='pages.explore.title'></FormattedMessage></h2>
        </div>
      </div>
      <div className='fluid-container content-wrapper'>
        <InviteUserToRegisterComponent />
        <div>&nbsp;</div>
        <TypeaheadUserPublicComponent />
        <div>
          <FormattedMessage id='pages.explore.alternative' />
        </div>
        <ExploreAlternativeListComponent />
      </div>
    </div>
  );
}
